import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { adminService } from '../../services/api';

const { Option } = Select;

// --- CORRECCIÓN: Se añade 'submitting' a las props
const RoleForm = ({ open, onCancel, onFinish, initialValues, submitting }) => {
    const [form] = Form.useForm();
    const [profiles, setProfiles] = useState([]);
    const isEditing = !!initialValues;

    useEffect(() => {
        const fetchProfiles = async () => {
            try {
                const { data } = await adminService.getProfiles();
                if (data.success) {
                    setProfiles(data.data);
                }
            } catch (error) {
                console.error('No se pudieron cargar los perfiles de permisos.');
            }
        };
        if (open) {
            fetchProfiles();
        }
    }, [open]);

    useEffect(() => {
        if (open) {
            if (isEditing) {
                form.setFieldsValue({
                    ...initialValues,
                    profile: initialValues.profile?._id,
                });
            } else {
                form.resetFields();
            }
        }
    }, [open, initialValues, form, isEditing]);


    const handleOk = () => {
        form.validateFields()
            .then(values => {
                onFinish(values);
            })
            .catch(info => {
                // --- CORRECCIÓN: Se notifica al usuario si la validación falla
                message.warning('Por favor, complete todos los campos requeridos.');
                console.log('Validate Failed:', info);
            });
    };

    return (
        <Modal
            title={isEditing ? 'Editar Rol' : 'Crear Rol'}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            // --- CORRECCIÓN: Se utiliza el estado 'submitting' para el botón OK
            okButtonProps={{ loading: submitting }}
            okText={isEditing ? 'Guardar Cambios' : 'Crear'}
            cancelText="Cancelar"
            destroyOnClose
        >
            <Form form={form} layout="vertical" name="role_form">
                <Form.Item
                    name="name"
                    label="Nombre del Rol"
                    rules={[{ required: true, message: 'Por favor, ingrese un nombre para el rol.' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="Descripción"
                >
                    <Input.TextArea rows={2} />
                </Form.Item>
                <Form.Item
                    name="profile"
                    label="Perfil de Permisos"
                    rules={[{ required: true, message: 'Por favor, seleccione un perfil.' }]}
                >
                    <Select placeholder="Seleccione un perfil de permisos">
                        {profiles.map(profile => (
                            <Option key={profile._id} value={profile._id}>
                                {profile.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RoleForm;
